import { render, staticRenderFns } from "./ConnectLoginButton.vue?vue&type=template&id=34fcc483"
import script from "./ConnectLoginButton.vue?vue&type=script&lang=js"
export * from "./ConnectLoginButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports